<template>
  <div v-if="isShow">
    <div class="btn" role="button" :selected="state" @click.stop="change" >
      <div class="nr">
        <img v-if="iconUrl" :src="iconUrl"
            style="width: 15px"/>
        <button v-text="text"></button>
        <div class="group-tip" v-if="isTipCover" @click.stop="cancelTip">
          <div class="group-img"></div>
        </div>
      </div>
      <div v-if="isTipCover" class="group-cover" @click.stop="cancelTip"></div>
    </div>
    <div class="btn cancel" role="button" v-show="isCancel" @click.stop="cancel" >
      <div class="nr">
        <button>取消</button>
      </div>
    </div>
    <!-- 添加个保存组件 -->
    <save-group  class="group-save" v-if="dialogFormVisible" :dialogFormVisible="dialogFormVisible" @confirm="save" @cancel="cancelSave"/>
  </div>
</template>
<script>
import SaveGroup from '@/components/content/SaveGroup'
import cache from '@/assets/lib/cache'
import { mapState } from 'vuex'
export default {
  name: 'DTITButton',
  props: ['state', 'text', 'iconUrl', 'type', 'isCancel', 'isCover'],
  data () {
    return {
      isTipCover: false,
      dialogFormVisible: false
    }
  },
  inject: {
    all: {
      default: () => {}
    }
  },
  components: {
    SaveGroup
  },
  computed: {
    ...mapState(['devices']),
    // 新版有分组功能
    isShow () {
      return this.devices[0] && this.devices[0]['version'] >= 45
    }
  },
  watch: {
    isCover () {
      this.isTip()
      this.dialogFormVisible = this.isCover
    }
  },
  activated () {
    this.isTip()
    this.dialogFormVisible = this.isCover
  },
  methods: {
    change (e) {
      if (!this.isTipCover) {
        this.$emit('change')
      }
      if (this.state) {
        this.dialogFormVisible = true
      }
    },
    // 判断是否已经进行过提示图标
    isTip () {
      let list = cache.getCache('groupTip')
      if (!list || !list[this.type]) {
        this.isTipCover = true
      }
    },
    // 取消弹框
    cancelTip () {
      let list = cache.getCache('groupTip')
      if (!list) list = {}
      list[this.type] = true
      this.isTipCover = false
      cache.setCache('groupTip', list, 7)
    },
    // 取消事件
    cancel () {
      this.$emit('cancel')
    },
    // 保存组
    save (data) {
      this.dialogFormVisible = data.isShow
      this.$emit('save', data)
      // 如果修改
      if (this.isCover) {
        this.$router.back()
      }
    },
    cancelSave (data) {
      this.dialogFormVisible = data.isShow
      if (this.isCover) {
        this.$router.back()
      }
    }
  },
  mounted () {
    this.isTip()
    this.dialogFormVisible = this.isCover
  }
}
</script>
<style scoped lang="less">
*{
  margin: 0;
  padding: 0;
  -webkit-tap-highlight-color:transparent;
}
.btn[selected] {
  border: 1px solid #39d474;
  background-color: #52c57e;
  button {
    color: white;
  }
}

.btn {
  display: inline-block;
  background-color: white;
  cursor: pointer;
  border: 1px solid rgba(218, 218, 218, 1);
  border-radius: 2px;
  height: 39px;
  //position: relative;
  line-height: 37px;
  padding: 10px;
  > div {
    width: 100%;
    height: 100%;
    display: flex;

    > button {
      cursor: pointer;
      background: transparent;
      border: 0;
      outline: 0 none !important;
      padding: 0;
      font-size: 13px;
      font-weight: 400;
      color: #1c324f;
    }
      img {
    margin-right: 6px;
    vertical-align: middle;
    // margin-left: 12px;
    }
  }
  > .nr {
    position: relative;
  }
}
.group-cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background: #000;
  opacity: 0.4;
  overflow: hidden;
}
.group-tip {
  position: absolute;
  top: 10px;
  left: -313px;
   z-index: 10000;
  width: 514px;
  height: 250px;
  display: flex;
  justify-content: center;
  .group-img {
    width: 514px;
    background: url('../assets/images/group/tips.png') no-repeat center;
    background-size: contain;
  }

}
.cancel {
  margin-left: 20px;
}
.group-save {
  z-index: 9999999;
}
</style>
